import React, { useEffect } from "react";
import { Box, Divider, Snackbar, IconButton, Grid, Chip } from "@mui/material";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from "../layouts/Topbar";
import Sidebarr from "../layouts/Sidebar";
import Header from "../components/Header";
import { fetchToken } from "../auth/Token";
import { Button } from "@mui/material";
import { api } from "../api";
import { useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "sonner";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CommodityManager = () => {
  const [allWarehouse, setAllWarehouse] = useState([]);
  const location = useLocation();
  const society_id = location.state && location.state.society_id;
  const society_name = location.state && location.state.name;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [commoditiesData, setCommoditiesData] = useState({
    warehouse: "",
    commodities: [],
    community: "",
    society_id: society_id,
    rebagging_fee: 0,
    stacking_fee: 0,
    destoning_fee: 0,
    cleaning_fee: 0,
    storage_fee: 0,
    tax_fee: 0,
    stitching_fee: 0,
    loading_fee: 0,
    empty_sack_cost_fee: 0,
  });
  const [myCommodities, setMyCommodities] = useState([]);
  const [openn, setOpenn] = React.useState(false);

  const handleCloss = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  useEffect(() => {
    api
      .get(`/account/commodities/${society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMyCommodities(response.data?.All_Commodities);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [society_id]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCommoditiesData({
      warehouse: "",
      commodities: [],
      community: "",
      society_id: society_id,
      rebagging_fee: null,
      stacking_fee: null,
      destoning_fee: null,
      cleaning_fee: null,
      storage_fee: null,
      tax_fee: null,
      stitching_fee: null,
      loading_fee: null,
      empty_sack_cost_fee: null,
    });
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (type === "checkbox") {
      setCommoditiesData({
        ...commoditiesData,
        [name]: checked,
      });
    } else {
      setCommoditiesData({
        ...commoditiesData,
        [name]: value,
      });
    }
  };

  const getCommoditiesAccount = async () => {
    await api
      .get(`/account/commodity/${society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAllWarehouse(response.data?.Warehouse);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getCommoditiesAccount();
  }, []);
  //   console.log(allWarehouse);

  const createCommodities = (event) => {
    event.preventDefault();
    handleOpen();
    api
      .post("/account/commodity", commoditiesData, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        setCommoditiesData({
          warehouse: "",
          commodities: [],
          community: "",
          society_id: society_id,
          rebagging_fee: null,
          stacking_fee: null,
          destoning_fee: null,
          cleaning_fee: null,
          storage_fee: null,
          tax_fee: null,
          stitching_fee: null,
          loading_fee: null,
          empty_sack_cost_fee: null,
        });
        setOpen(false);
        getCommoditiesAccount();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        handleCloss();
      });
  };

  // console.log(myCommodities);

  const handleClick = (house_com_id, name, cash_worth) => {
    navigate("/warehouse", {
      state: {
        id: house_com_id,
        name: name,
        society: society_name,
        society_id: society_id,
        cash_worth: cash_worth,
      },
    });
  };

  const [commodity_sum, setCommodity_sum] = useState([]);
  const [total_data, setTotal_data] = useState([]);
  const [prices, setPrices] = useState([]);

  const handleSumuryBeforeEnter = () => {
    api
      .get(`/commodity/at/a/glance/${society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCommodity_sum(response.data?.Data);
        setTotal_data(response.data);
        setPrices(response.data?.prices);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    handleSumuryBeforeEnter();
  }, []);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="Warehouse" />
          </Box>
          <Card sx={{ margin: 4, textAlign: "center" }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Commodity Accounts
              </Typography>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                <Button variant="outlined" onClick={handleClickOpen}>
                  Setup a Warehouse
                </Button>
              </Typography>
            </CardContent>
            <CardActions style={{ maxWidth: 999, overflowX: "auto" }}>
              <Chip
                sx={{
                  height: "auto",
                  "& .MuiChip-label": {
                    display: "block",
                    whiteSpace: "normal",
                  },
                }}
                color="info"
                variant="outlined"
                label={
                  <div style={{ margin: 1 }}>
                    {/* <Typography align="center" fontStyle='oblique'><b>{item.commodity}</b></Typography> */}
                    <Typography fontStyle="oblique">
                      Total members asssociated:<b>{total_data.Members}</b>
                    </Typography>
                    <Typography fontStyle="oblique">
                      Total savings groups related:
                      <b>{total_data.associations}</b>
                    </Typography>
                  </div>
                }
              />
              {commodity_sum.map((item) => (
                <div style={{ display: "flex" }}>
                  <Chip
                    sx={{
                      height: "auto",
                      "& .MuiChip-label": {
                        display: "block",
                        whiteSpace: "normal",
                      },
                    }}
                    color="success"
                    variant="outlined"
                    key={item.commodity_id}
                    label={
                      <div style={{ margin: 1 }}>
                        <Typography align="center" fontStyle="oblique">
                          <b>{item.commodity}</b>
                        </Typography>
                        <Typography fontStyle="oblique">
                          Total bags:<b>{item.total_number}</b>
                        </Typography>
                        <Typography fontStyle="oblique">
                          Worth:
                          <b style={{ color: "#3a5a40" }}>
                            {currencyFormat.format(item.commodity_cash_value)}
                          </b>
                        </Typography>
                        <Divider variant="middle" />
                        {prices.map((itemm) =>
                          itemm.id === item.commodity_id
                            ? itemm.price.map((i) => (
                                <Typography fontStyle="oblique">
                                  {i.grade}:
                                  <b style={{ color: "#3a5a40" }}>
                                    {currencyFormat.format(i.price_per_kg)}
                                  </b>
                                </Typography>
                              ))
                            : null
                        )}
                      </div>
                    }
                  />
                </div>
              ))}
            </CardActions>
          </Card>
          <Divider variant="middle" />
          <Grid container spacing={2}>
            {allWarehouse.map((item) => (
              <Grid item md={4}>
                <Card sx={{ minWidth: 280, margin: 4 }}>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {item.warehouse.includes("Warehouse") ||
                      item.warehouse.includes("warehouse") ||
                      item.warehouse.includes("Wearhouse") ||
                      item.warehouse.includes("wearhouse")
                        ? item.warehouse
                        : `${item.warehouse} Warehouse`}
                    </Typography>
                    <Typography fontStyle="Italic" variant="body2">
                      Community:{" "}
                      <b style={{ color: "black" }}>{item.community}</b>
                    </Typography>
                    <Typography fontStyle="Italic" variant="subtitle">
                      Worth:{" "}
                      <b>{currencyFormat.format(item.total_cash_value)}</b>
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <IconButton
                      onClick={() =>
                        handleClick(
                          item.id,
                          item.warehouse,
                          item.total_cash_value
                        )
                      }
                    >
                      <FileOpenOutlinedIcon />
                    </IconButton>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Setup Warehouse</DialogTitle>
            <DialogContent>
              <DialogContentText>
                This {commoditiesData.warehouse} warehouse will be active after
                setup.
              </DialogContentText>
              <TextField
                required
                margin="dense"
                id="warehouse"
                name="warehouse"
                label="Warehouse"
                onChange={handleInputChange}
                value={commoditiesData.warehouse}
                type="text"
                fullWidth
                variant="outlined"
              />
              <Select
                options={myCommodities.map((item) => ({
                  label: item.commodity,
                  value: item.id,
                }))}
                onChange={(selectedOption) => {
                  setCommoditiesData({
                    ...commoditiesData,
                    commodities: selectedOption.map((item) => item.value),
                  });
                }}
                isMulti
                name="commodities"
              />
              <TextField
                required
                margin="dense"
                id="community"
                name="community"
                label="Community Name"
                onChange={handleInputChange}
                type="text"
                value={commoditiesData.community}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="rebagging_fee"
                name="rebagging_fee"
                label="Rebagging fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.rebagging_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="stacking_fee"
                name="stacking_fee"
                label="Stacking fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.stacking_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="destoning_fee"
                name="destoning_fee"
                label="Destoning fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.destoning_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="cleaning_fee"
                name="cleaning_fee"
                label="Cleaning f/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.cleaning_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="stitching_fee"
                name="stitching_fee"
                label="Stitching fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.stitching_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="loading_fee"
                name="loading_fee"
                label="Loading fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.loading_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="tax_fee"
                name="tax_fee"
                label="Tax /bag"
                onChange={handleInputChange}
                type="numeric"
                step={0.01}
                value={commoditiesData.tax_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="empty_sack_cost_fee"
                name="empty_sack_cost_fee"
                label="Empty sack cost"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.empty_sack_cost_fee}
                fullWidth
                variant="outlined"
              />
              <TextField
                required
                margin="dense"
                id="storage_fee"
                name="storage_fee"
                label="Storage fee/bag"
                onChange={handleInputChange}
                type="numeric"
                value={commoditiesData.storage_fee}
                fullWidth
                variant="outlined"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={createCommodities}>Finish</Button>
            </DialogActions>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={openn}
              onClick={handleCloss}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Dialog>
        </Box>
      </main>
    </div>
  );
};
export default CommodityManager;
